import BaseReportPDFGenerator from "../../reports/BaseReportPDFGenerator";
import PDFDefinitionCreator from "./PDFDefinitionCreator";
import {DateFormat} from "../../date_format"
import PDFParametersFormattingStrategy from "./PDFParametersFormattingStrategy";

export default class PDFGenerator extends BaseReportPDFGenerator {
    init(store, generalStore, productSettingsValidator, reportRightsValidator)
    {
        super.init(store, generalStore, productSettingsValidator, reportRightsValidator);

        this.docDefinitionCreator = new PDFDefinitionCreator();

        return this;
    }

    _getParametersFormattingStrategy(config)
    {
        var dateFormatForFileName = new DateFormat('yyyy-MM-dd');
        return (new PDFParametersFormattingStrategy()).init(
            {
                cpList: this.generalStore.getCPList(),
                projectsWithMaIds: this.generalStore.getProjectsWithMaIds(),
                dateFormat: config.dateFormat,
                dateFormatForFile: dateFormatForFileName,
                productSettingsValidator : this.productSettingsValidator,
                reportRightsValidator : this.reportRightsValidator
            }
        );
    }
}


// WEBPACK FOOTER //
// ./web/js/pdf/evaReport/PDFGenerator.js